import * as Sentry from '@sentry/react';
import { exportContractsUploadTemplate } from 'api/contract.api';
import {
  contractsPaths,
  globalPaths,
  incidencePaths,
  usersPaths,
} from 'constants/routePaths';
import { useEmployeeActions } from 'hooks/useEmployeeActions';
import notificationHook from 'hooks/notificationHook';
import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router';
import statusMessages from 'statusMessages';
import { ApiError } from 'types';

export const useUserListActions = () => {
  const navigate = useNavigate();
  const employeeActions = useEmployeeActions();
  const [exportContractsLoading, setExportContractsLoading] = useState(false);

  const onExportContracts = useCallback(async () => {
    setExportContractsLoading(true);
    try {
      const response = await exportContractsUploadTemplate();
      const fileUrl = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = fileUrl;
      link.setAttribute('download', 'prosinergia-contratos-existentes.xlsx');
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(fileUrl);
    } catch (error) {
      Sentry.captureException(error);
      const currentStatus = (error as ApiError).statusCode;
      notificationHook({
        message: statusMessages.contract[
          currentStatus ? currentStatus : 500
        ] as string,
        type: 'error',
      });
    } finally {
      setExportContractsLoading(false);
    }
  }, []);

  const onUploadPhotos = useCallback(() => {
    navigate(`/${globalPaths.uploadPhotos}`);
  }, [navigate]);
  const onUploadEmployees = useCallback(() => {
    navigate(usersPaths.uploadUsers);
  }, [navigate]);
  const onUploadContracts = useCallback(() => {
    navigate(`${contractsPaths.basePath}/${contractsPaths.uploadContracts}`);
  }, [navigate]);
  const onAddEmployee = useCallback(() => {
    navigate(usersPaths.newUser);
  }, [navigate]);
  const onBulkReconcileIncidences = useCallback(() => {
    navigate(`${incidencePaths.basePath}/${incidencePaths.reconcileBulk}`);
  }, [navigate]);

  return {
    exportContractsLoading,
    impersonatingEmployeeId: employeeActions.impersonatingEmployeeId,
    onAddEmployee,
    onBulkReconcileIncidences,
    onExportContracts,
    onUploadContracts,
    onUploadEmployees,
    onUploadPhotos,
    rowActions: employeeActions.actions,
  };
};
